import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { GoldMark } from "@/components/common";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="section-pad flex min-h-[70vh] flex-col items-center justify-center pt-24 text-center">
      <GoldMark size={64} />
      <p className="mt-6 font-display text-6xl uppercase text-paper sm:text-8xl">404</p>
      <p className="mt-3 text-sm text-mist">{t("page.notfound")}</p>
      <Link to="/" className="btn-neon mt-8" data-testid="notfound-home">{t("page.backHome")}</Link>
    </div>
  );
}
